import { render } from "./Hero.vue?vue&type=template&id=02d7f52e&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=02d7f52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d7f52e"]])

export default __exports__